import Sortable from "sortablejs";

const tableMethods = {
  data() {
    return { lastClicked: null, lastIndex: null };
  },
  methods: {
    makeHeadersDraggable(skipFirstColumn = true) {
      const headerRow = this.$el.querySelector("thead tr");
      if (headerRow) {
        [...headerRow.children]
            // Optionally skip the leading item select column
            .slice(skipFirstColumn ? 1 : 0)
            // Filter out only headers with draggable flag in the header definition
            .filter((node, index) => this.headers[index].draggable)
            // Add the draggable class
            .forEach((node) => node.classList.add("draggable"));

        if (!Sortable.get(headerRow)) {
          Sortable.create(headerRow, {
            draggable: ".draggable",
            onStart: () => {
              headerRow.classList.add("dragging");
            },
            onEnd: (evt) => {
              headerRow.classList.remove("dragging");

              // Update our internal header representation:
              this.headers.splice(evt.newDraggableIndex, 0, this.headers.splice(evt.oldDraggableIndex, 1)[0]);

              // Undo the DOM change from Sortable.js. It is confusing the vue data table
              headerRow.insertBefore(headerRow.removeChild(headerRow.children[evt.newIndex]),
                  headerRow.children[evt.oldIndex]);
            }
          });
        }
      }
    },
    singleClick(item, row) {
      if (item.certid && item.certid === this.getOfficerDetails?.certid) {
        row.isSelected = false;
        this.showInfo = true
        this.infoMsg = "You can't select the user certificate"
        return;
      }
      
      if (item.regid) {
        this.selectedItems.pop();
        this.selectedItems[0] = item;
      }

      row.select(!row.isSelected);
    },
    doubleClick(event, { item }) {
      this.itemClicked(item);
    },
    rightClick(event, item) {
      // For changing the data table row background
      let x = document.getElementById("tableData").getElementsByTagName("tr");
      this.selectedItems = [];

      // Prevents the default right click action
      event.preventDefault();
      this.rightClickObject.showContext = false;

      // Checks if the current item was the last clicked
      if (this.lastClicked === item.item) {
        // Deselect the item if its last clicked
        this.selectedItems = [];

        x[item.index + 1].style.backgroundColor = "white"
        this.lastClicked = null;
        this.lastIndex = null;

        // Shows the popup
        this.rightClickObject.showContext = false;
      } else {
        // Clears the other rows
        x[this.lastIndex + 1].style.backgroundColor = "white"
        x[item.index + 1].style.backgroundColor = "#EFF2FE"

        // Clears the selected certs
        this.selectedItems = [];

        // Sets the current item, so the popup gets the correct information
        this.currentItem = item.item

        // Adds it to last clicked, so it can be cleared after right click
        this.lastClicked = item.item;
        this.lastIndex = item.index


        // Shows the popup menu
        this.rightClickObject.showContext = true;

        // Finds the x and y possition of the mouse to calculate where to open the dialog
        this.rightClickObject.posY = event.clientY;
        this.rightClickObject.posX = event.clientX;
        // For changing the data table row background
        this.selectedItems = [];
        // x[item.index + 1].style.backgroundColor="white"

      }
    },
    changeView() {
      if (this.fullView) {
        this.fullView = false;
      } else {
        this.fullView = true;
      }
    },
    itemClicked(item) {
      this.currentItem = item;
      this.viewItemDialog = true;
    },

    closeDialog() {
      this.currentItem = null;
      this.viewItemDialog = false;
      this.fullView = false;
    },
  },
  watch: {
    "rightClickObject.showContext"(ss) {
      if (ss === false) {
        let x = document.getElementById("tableData").getElementsByTagName("tr");
        x[this.lastIndex + 1].style.backgroundColor = "white"
      }
    }
  }
};

export default tableMethods;
